import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApplicationLog } from '../interfaces/application-log.interface';

@Injectable({
	providedIn: 'root',
})
export class ApplicationInsightsService {
	url: string = 'applicationInsights';

	constructor(private http: HttpClient) {}

	public getTraceparentInfo(traceparentId: string): Observable<any> {
		return this.http.get<any>(this.url  +'/' + traceparentId);
	}
}
